const getDefaultState = () => {
  return {
    Menages: [],
    MenagesDuGroupe: [],
    MenagesDuSuperviseur: [],
    ////////////////
    disable_next: false,
    disable_prev: false,
    //Save first document in snapshot of items received
    firstInResponse: [],
    //Save last document in snapshot of items received
    lastInResponse: [],
    //Keep the array of first document of previous pages
    prev_start_at: [],
    //Maintain the count of clicks on Next Prev button
    pagination_clicked_count: 0,
    paginationSize: 10,
    field: "ll_menage",
    whereField: "ll_menage",
    collection: "newMenages",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.Menages = payload;
  },

  SET_MENAGES_DUSUPERVISEUR(state, payload) {
    state.MenagesDuSuperviseur = payload;
  },

  SET_MENAGES_DU_GROUPE(state, payload) {
    state.MenagesDuGroupe = payload;
  },
  ///////////////////
  SET_DISABLE_NEXT(state, payload) {
    state.disable_next = payload;
  },
  SET_DISABLE_PREV(state, payload) {
    state.disable_prev = payload;
  },
  SET_firstInResponse(state, payload) {
    state.firstInResponse = payload;
  },
  SET_lastInResponse(state, payload) {
    state.lastInResponse = payload;
  },
  SET_prev_start_at(state, payload) {
    state.prev_start_at = payload;
  },
  SET_pagination_clicked_count(state, payload) {
    state.pagination_clicked_count = payload;
  },
  SET_prev_start_at(state, payload) {
    state.prev_start_at = payload;
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  ADD_ONE_ITEM(state, payload) {
    state.MenagesDuGroupe.push(payload);
    state.MenagesDuSuperviseur.push(payload);
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  addOneItem({ commit }, item) {
    commit("ADD_ONE_ITEM", item);
    console.log("added to Vuex Menages", item)
  },
  async GetAll({ commit }) {
    // start requête
    commit("SET_LISTE", []);

    commit("Loading/START_BUSY_STATE", "Menages GetAll", { root: true });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.Menages.collection)
      .orderBy(this.state.Menages.field)
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", null, { root: true });
          } else {
            console.log("tout est synchronisé Dans Menages GetAll");
            commit("Pending/END_PENDING_STATE", null, { root: true });
          }
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          commit("SET_prev_start_at", []);

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_firstInResponse", elems[0]);
            commit("SET_lastInResponse", elems[elems.length - 1]);
            commit("SET_pagination_clicked_count", 0);
            commit("SET_DISABLE_NEXT", false);
            commit("SET_DISABLE_PREV", false);

            //Push first item to use for Previous action
            let prev_start_at = [];
            prev_start_at.push(elems[0]);
            commit("SET_prev_start_at", prev_start_at);

            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "Menages.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "Menages.store.js", {
            root: true,
          });
        }
      );
  },
  async Get({ commit }) {
    // start requête
    commit("SET_LISTE", []);
    commit("Loading/START_BUSY_STATE", "Menages get", { root: true });
    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.Menages.collection)
      .orderBy(this.state.Menages.field)
      .limit(this.state.Menages.paginationSize)
      .get()
      .then(
        (snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
            commit("Pending/START_PENDING_STATE", null, { root: true });
          } else {
            console.log("tout est synchronisé dans Menages Get");
            commit("Pending/END_PENDING_STATE", null, { root: true });
          }
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          commit("SET_prev_start_at", []);

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_firstInResponse", elems[0]);
            commit("SET_lastInResponse", elems[elems.length - 1]);
            commit("SET_pagination_clicked_count", 0);
            commit("SET_DISABLE_NEXT", false);
            commit("SET_DISABLE_PREV", false);

            //Push first item to use for Previous action
            let prev_start_at = [];
            prev_start_at.push(elems[0]);
            commit("SET_prev_start_at", prev_start_at);

            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "Menages.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "Menages.store.js", {
            root: true,
          });
        }
      );
  },

  async nextPage({ commit }) {
    let elems = [];
    let self = this;

    commit("SET_DISABLE_NEXT", true);
    await this._vm.$firebase
      .firestore()
      .collection(this.state.Menages.collection)
      .orderBy(this.state.Menages.field)
      .startAfter(this.state.Menages.lastInResponse.ll_menage)
      .limit(this.state.Menages.paginationSize)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          commit("SET_LISTE", elems);

          if (!elems.length) {
            commit("SET_DISABLE_NEXT", true);
          }

          commit("SET_firstInResponse", elems[0]);
          commit("SET_lastInResponse", elems[elems.length - 1]);

          commit(
            "SET_pagination_clicked_count",
            self.state.Menages.pagination_clicked_count++
          );
          self.state.Menages.pagination_clicked_count++;
          commit("SET_DISABLE_PREV", false);
          //Push first item to use for Previous action
          let prev_start_at = this.state.Menages.prev_start_at;
          prev_start_at.push(elems[0]);
          commit("SET_prev_start_at", prev_start_at);
          commit("SET_DISABLE_NEXT", false);
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("SET_DISABLE_NEXT", false);
        }
      );
  },

  async prevPage({ commit }) {
    let prev_start_at = this.state.Menages.prev_start_at;
    if (prev_start_at.length > this.state.Menages.pagination_clicked_count + 1)
      prev_start_at.splice(prev_start_at.length - 2, prev_start_at.length - 1);
    let get_prev_startAt =
      prev_start_at[this.state.Menages.pagination_clicked_count - 1];
    //console.log(get_prev_startAt);
    let elems = [];
    let self = this;
    commit("SET_DISABLE_PREV", true);
    await this._vm.$firebase
      .firestore()
      .collection(this.state.Menages.collection)
      .orderBy(this.state.Menages.field)
      .startAt(get_prev_startAt.ll_menage)
      .endBefore(self.state.Menages.firstInResponse.ll_menage)
      .limit(this.state.Menages.paginationSize)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          commit("SET_LISTE", elems);

          if (!elems.length) {
            commit("SET_DISABLE_NEXT", true);
          }

          commit("SET_firstInResponse", elems[0]);
          commit("SET_lastInResponse", elems[elems.length - 1]);

          //Maintaing page no.
          commit(
            "SET_pagination_clicked_count",
            self.state.Menages.pagination_clicked_count--
          );
          self.state.Menages.pagination_clicked_count--;

          //Pop not required value in array
          let prev_start_at = self.state.Menages.prev_start_at;
          prev_start_at.forEach((element) => {
            if (elems[0].id == element.id) {
              element = null;
            }
          });
          commit("SET_prev_start_at", prev_start_at);

          //Enable buttons again
          commit("SET_DISABLE_PREV", false);
          commit("SET_DISABLE_NEXT", false);
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("SET_DISABLE_PREV", false);
        }
      );
  },
  async GetMenagesDuSuperviseur({ commit }, objet) {
    let self = this;
    commit("SET_MENAGES_DUSUPERVISEUR", []);
    commit("RESET_STATE");
    // start requête

    commit("Loading/START_BUSY_STATE", "GetMenagesDuSuperviseur", {
      root: true,
    });
    let elems = [];
    let elemsTemp = [];
    await this._vm.$firebase
      .firestore()
      .collection("newMenages")
      .where("id_responsable", "==", objet.userId)
      .where("projectList", "array-contains", objet.project.id)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elemsTemp.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elemsTemp) {
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = "Pas d'éléments";
            commit("Snackbar/SET_SNACKBAR", snack, { root: true });
            return false;
          } else {
            commit("SET_MENAGES_DUSUPERVISEUR", elemsTemp);
            commit("Loading/END_BUSY_STATE", "menages.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("Loading/END_BUSY_STATE", "menages.store.js", { root: true });
        }
      );
  },
  async GetMenagesDuGroupe({ commit }, groupeId) {
    let self = this;
    commit("SET_MENAGES_DU_GROUPE", []);

    // start requête

    commit("Loading/START_BUSY_STATE", "GetMenagesDuGroupe menages.store.js", {
      root: true,
    });

    let elemsTemp = [];
    await this._vm.$firebase
      .firestore()
      .collection("newMenages")
      .where("id_groupe", "==", groupeId)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elemsTemp.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elemsTemp) {
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = "Pas d'éléments";
            commit("Snackbar/SET_SNACKBAR", snack, { root: true });
            return false;
          } else {
            commit("SET_MENAGES_DU_GROUPE", elemsTemp);
            commit(
              "Loading/END_BUSY_STATE",
              "GetMenagesDuGroupe menages.store.js",
              {
                root: true,
              }
            );
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit(
            "Loading/END_BUSY_STATE",
            "GetMenagesDuGroupe menages.store.js",
            { root: true }
          );
        }
      );
  },
};

const getters = {
  Menages: (state) => {
    return state.Menages;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
